const Ext = require('ext')
const t = require('translate')
const AddressableActionClause = require('smartrules/designer/actions/AddressableActionClause')
const AddressMatcher = require('smartrules/designer/matchers/AddressMatcher')
const ListMatcher = require('smartrules/designer/matchers/ListMatcher')
const ListTypes = require('smartrules/ListTypes')

const RedirectTo = Ext.define(null, {
  extend: AddressableActionClause,

  constructor(cfg) {
    cfg = Ext.applyIf(cfg || {}, {
      label: t('Redirect message to'),
      matchers: [
        {
          matcher: 'is',
          name: t('address'),
          clazz: AddressMatcher,
          dsl: 'redirect message to {0}'
        },
        {
          matcher: 'is-in',
          name: t('address list'),
          clazz: ListMatcher,
          matcherType: ListTypes.RULE_ADDRESS,
          dsl: 'redirect message to {0}'
        }
      ],
      nestable: true,
      type: 'smartrules-redirect-to'
    })
    this.callParent([cfg])
  }
})

module.exports = RedirectTo
